import { memo as _$memo } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { createComponent as _$createComponent } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { For, Show } from "solid-js";
import { theme } from "../theme";
import { formatCell } from "../utils/format";
function isNumericValue(value) {
  if (value === null || value === undefined) return false;
  return typeof value === "number" || !isNaN(Number(value));
}
export function DataGrid(props) {
  const getColumnWidth = (colName, index) => {
    const rows = props.store.rows();
    const headerLen = colName.length + 2;
    const maxContentLen = rows.reduce((max, row) => {
      const val = row[colName];
      const len = String(val ?? "NULL").length;
      return Math.max(max, len);
    }, 0);
    return Math.min(Math.max(headerLen, maxContentLen) + 2, 32);
  };
  return (() => {
    var _el$ = _$createElement("box");
    _$setProp(_el$, "flexGrow", 1);
    _$setProp(_el$, "border", true);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.store.rows().length > 0;
      },
      get fallback() {
        return (() => {
          var _el$5 = _$createElement("box"),
            _el$6 = _$createElement("text");
          _$insertNode(_el$5, _el$6);
          _$setProp(_el$5, "padding", 2);
          _$insert(_el$6, () => props.store.loading().rows ? "Loading..." : "No data");
          _$effect(_$p => _$setProp(_el$6, "style", {
            fg: theme.colors.textDim
          }, _$p));
          return _el$5;
        })();
      },
      get children() {
        var _el$2 = _$createElement("scrollbox"),
          _el$3 = _$createElement("box"),
          _el$4 = _$createElement("box");
        _$insertNode(_el$2, _el$3);
        _$setProp(_el$2, "stickyScroll", false);
        _$insertNode(_el$3, _el$4);
        _$setProp(_el$3, "flexDirection", "column");
        _$setProp(_el$4, "flexDirection", "row");
        _$setProp(_el$4, "paddingLeft", 1);
        _$setProp(_el$4, "paddingRight", 1);
        _$setProp(_el$4, "borderBottom", true);
        _$insert(_el$4, _$createComponent(For, {
          get each() {
            return props.store.columns();
          },
          children: (col, idx) => {
            const width = getColumnWidth(col.name, col.cid);
            const isSelected = () => idx() === props.store.selectedColumnIndex() && props.focused;
            const currentSort = () => props.store.sort();
            const sortIndicator = () => {
              const sort = currentSort();
              if (sort.col === col.name) {
                return sort.dir === "ASC" ? " ▲" : " ▼";
              }
              return "  ";
            };
            return (() => {
              var _el$7 = _$createElement("box"),
                _el$8 = _$createElement("text");
              _$insertNode(_el$7, _el$8);
              _$setProp(_el$7, "width", width);
              _$setProp(_el$7, "paddingRight", 1);
              _$insert(_el$8, (() => {
                var _c$ = _$memo(() => !!isSelected());
                return () => _c$() ? (() => {
                  var _el$9 = _$createElement("b");
                  _$insert(_el$9, () => col.name, null);
                  _$insert(_el$9, sortIndicator, null);
                  return _el$9;
                })() : [_$memo(() => col.name), _$memo(sortIndicator)];
              })());
              _$effect(_$p => _$setProp(_el$8, "style", {
                fg: isSelected() ? theme.colors.text : theme.colors.textDim
              }, _$p));
              return _el$7;
            })();
          }
        }));
        _$insert(_el$3, _$createComponent(For, {
          get each() {
            return props.store.rows();
          },
          children: (row, idx) => (() => {
            var _el$0 = _$createElement("box");
            _$setProp(_el$0, "flexDirection", "row");
            _$setProp(_el$0, "paddingLeft", 1);
            _$setProp(_el$0, "paddingRight", 1);
            _$insert(_el$0, _$createComponent(For, {
              get each() {
                return props.store.columns();
              },
              children: col => {
                const width = getColumnWidth(col.name, col.cid);
                const value = row[col.name];
                const isNull = value === null || value === undefined;
                const isNum = isNumericValue(value);
                const formatted = formatCell(value, width - 2);
                return (() => {
                  var _el$1 = _$createElement("box"),
                    _el$10 = _$createElement("text");
                  _$insertNode(_el$1, _el$10);
                  _$setProp(_el$1, "width", width);
                  _$setProp(_el$1, "paddingRight", 1);
                  _$insert(_el$10, formatted);
                  _$effect(_$p => _$setProp(_el$10, "style", {
                    fg: isNull ? theme.colors.null : isNum ? theme.colors.number : theme.colors.string
                  }, _$p));
                  return _el$1;
                })();
              }
            }));
            _$effect(_$p => _$setProp(_el$0, "backgroundColor", idx() === props.store.selectedRowIndex() && props.focused ? theme.colors.selected : theme.colors.background, _$p));
            return _el$0;
          })()
        }), null);
        _$effect(_p$ => {
          var _v$ = {
              flexGrow: 1,
              rootOptions: {
                backgroundColor: theme.colors.background
              },
              scrollbarOptions: {
                showArrows: true
              }
            },
            _v$2 = theme.colors.backgroundAlt,
            _v$3 = {
              borderColor: theme.colors.border
            };
          _v$ !== _p$.e && (_p$.e = _$setProp(_el$2, "style", _v$, _p$.e));
          _v$2 !== _p$.t && (_p$.t = _$setProp(_el$4, "backgroundColor", _v$2, _p$.t));
          _v$3 !== _p$.a && (_p$.a = _$setProp(_el$4, "style", _v$3, _p$.a));
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        return _el$2;
      }
    }));
    _$effect(_p$ => {
      var _v$4 = props.focused ? theme.colors.borderActive : theme.colors.border,
        _v$5 = {
          backgroundColor: theme.colors.background,
          flexDirection: "column"
        };
      _v$4 !== _p$.e && (_p$.e = _$setProp(_el$, "borderColor", _v$4, _p$.e));
      _v$5 !== _p$.t && (_p$.t = _$setProp(_el$, "style", _v$5, _p$.t));
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}